'use strict';

var angular = require('angular');
var DeleteDiscontinuedRouteModalDirective = function DeleteDiscontinuedRouteModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/delete-discontinued-route-modal.html'),
    link: function link($scope, element) {
      $scope.hideDialogAndRemoveDiscontinuedRoutes = function () {
        $scope.removeDiscontinuedRoutes();
        $scope.showDeleteModal = false;
      };
      $scope.cancelRemoveDiscontinuedRoutes = function () {
        $scope.$broadcast('grid:dataChanged');
        $scope.showDeleteModal = false;
      };
      $scope.$watch('showDeleteModal', function (newVal) {
        if (newVal) {
          angular.element('#delete-discontinued-route-modal').modal('show');
        } else {
          element.parent('.modal:first').modal('hide');
        }
      });
    }
  };
};
DeleteDiscontinuedRouteModalDirective.$inject = [];
module.exports = DeleteDiscontinuedRouteModalDirective;